import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { IPartMediaImage } from 'parts/types';

import { DefaultCheckbox } from './DefaultCheckbox';

interface IProps {
  image: IPartMediaImage;
  canMakeDefault: boolean;
  onMakeDefault: (fileId: number) => void;
}

const ImageExtraInfoBase = ({ image, canMakeDefault, onMakeDefault }: IProps) => {
  const { t } = useTranslation();

  const isDefault = !!image.isDefault;

  if (!isDefault && (!canMakeDefault || !image.fileId)) {
    return null;
  }

  return (
    <DefaultCheckbox
      isDefault={isDefault}
      defaultLabel={t('labelDefaultImage')}
      makeDefaultLabel={t('labelMakeAsDefault')}
      onMakeDefault={canMakeDefault && image.fileId ? () => onMakeDefault(image.fileId) : undefined}
    />
  );
};

export const ImageExtraInfo = memo(ImageExtraInfoBase);
